import * as React from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { getCarCompaniesBySearch } from 'modules/orderManagement/action';

interface Props {
    onSelectCarCompany: (carCompany: any | null) => void;
}

export default function CarCompaniesDropdown({
    onSelectCarCompany
}: Props) {
    const dispatch: any = useDispatch();

    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [options, setOptions] = React.useState<any[]>([]);
    const [value, setValue] = React.useState<any>(null);

    React.useEffect(() => {
        fetchCarCompanies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const fetchCarCompanies = () => {
        setLoading(true);
        dispatch(getCarCompaniesBySearch(search, (result: any[]) => {
            setOptions(Array.isArray(result) ? result : []);
            setLoading(false);
        }));
    }

    const handleOpen = () => {
        setOpen(true);
        fetchCarCompanies();
    };

    const handleClose = () => {
        setOpen(false);
        setOptions([]);
    };

    return (
        <Autocomplete
            fullWidth
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            isOptionEqualToValue={(option, selected) =>
                option?.id === selected?.id || option?._id === selected?._id
            }
            getOptionLabel={(option: any) => option?.name || ""}
            options={options}
            loading={loading}
            onChange={(_, selected) => {
                setValue(selected);
                setSearch(selected?.name || "");
                onSelectCarCompany(selected);
            }}
            renderOption={(props, option, _, ownerState) => {
                const { key, ...optionProps } = props;
                return (
                    <Box
                        key={key}
                        component="li"
                        {...optionProps}
                    >
                        {ownerState.getOptionLabel(option)}
                    </Box>
                );
            }}
            inputValue={value ? value.name || "" : search}
            onInputChange={(_, newInputValue, reason) => {
                if (reason === "input") {
                    setValue(null);
                    onSelectCarCompany(null);
                    setSearch(newInputValue);
                } else if (reason === "clear") {
                    setValue(null);
                    onSelectCarCompany(null);
                    setSearch("");
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={"Select Company"}
                />
            )}
        />
    );
}
